import { createFileRoute } from '@tanstack/react-router'

import { HubSpotSection } from '@/components/Internal/GlobalConfig/HubSpotSection'

export const Route = createFileRoute('/internal/system/settings/hubspot')({
  component: HubSpotSection,
})
